















































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import DeleteDialog from '@c/DeleteDialog.vue';
import axios from 'axios';
import Loading from '@c/controls/Loading.vue';
import ConditionForm from './ConditionForm.vue';

@Component({
  components: {
    DeleteDialog,
    ConditionForm,
    Loading,
  },
})
export default class TreeTable extends Vue {
  @Prop() title!: string;
  @Prop({default: false, type: Boolean}) dense!: boolean;
  @Prop({default: true, type: Boolean}) editable!: boolean;

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  nonNegativeNumberRule = (v: any) => v >= 0 || 'Поле должно быть неотрицательным числом';

  positiveNumberRule = (v: any) => v > 0 || 'Поле должно быть положительным числом';

  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  // Источник данных
  @Prop({required: true}) apiStore!: any;

  @Prop({required: true}) addGroupCallback!: Function;
  @Prop({required: true}) addConditionCallback!: Function;
  @Prop({required: true}) deleteTreeCallback!: Function;
  @Prop({required: true}) deleteGroupCallback!: Function;
  @Prop({required: true}) deleteConditionCallback!: Function;

  loading = false;
  error = false;

  @Prop() groupDialog: any;
  @Prop() conditionDialog: any;

  get unstatusItems() {
    return [
      {
        name: 'Выключено',
        value: 0,
      },
      {
        name: 'Холостой режим',
        value: 1,
      },
      {
        name: 'Рабочий режим',
        value: 2,
      },
      {
        name: 'Ошибка',
        value: 3,
      },
    ];
  }

  get items(): Array<{
    [key: string]: any;
  }> {
    return [...this.apiStore];
  }

  addGroup(itemId: number) {
    this.openGroupAddDialog(itemId);
  }

  addCondition(itemID: number, conditionIndex: number) {
    this.openConditionAddDialog(itemID, conditionIndex);
  }

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  deleteItem(itemID: number) {
    this.deleteDialog.open(itemID, {
      deleteCallback: async () => {
        try {
          this.deleteTreeCallback(itemID);
          this.deleteDialog.close();
        } catch (e) {
          this.deleteDialog.error('Произошла ошибка');
        }
      },
    });
  }

  deleteGroup(itemID: number, groupIndex: number) {
    this.deleteDialog.open(itemID, {
      deleteCallback: async () => {
        try {
          this.deleteGroupCallback(itemID, groupIndex);
          this.deleteDialog.close();
        } catch (e) {
          this.deleteDialog.error('Произошла ошибка');
        }
      },
    });
  }

  // TODO: реализовать в контексте apiStore
  async openGroupAddDialog(itemID: number) {
    const dialog = this.$refs.groupDialog as any;
    const options = {
      saveCallback: (data: any) => {
        dialog.$refs.form.reset();
        dialog.close();
        this.addGroupCallback(itemID, data);
      },
    };

    //TODO: CancelToken и axios должен быть в store
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const request = {
      data: {
        is_not: false,
        name: '',
        and_conditions: [],
      },
    };

    dialog.openAsync(request, source, options);
  }

  async openConditionAddDialog(itemID: number, groupIndex: number) {
    const dialog = this.$refs.conditionDialog as any;
    const options = {
      saveCallback: (data: any) => {
        dialog.$refs.form.reset();
        dialog.close();
        this.addConditionCallback(itemID, groupIndex, data);
      },
    };

    //TODO: CancelToken и axios должен быть в store
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const request = {
      data: {
        name: '',
        module_id: '',
        message_type: '',
        field_name: '',
        statement: '',
        value: '',
        is_not: false,
      },
    };

    dialog.openAsync(request, source, options);
  }
}
